import dnrLogo from '../images/DNR-Pest-Logo.png';
import roachVideoWebM from '../video/roaches.webm';
import roachVideoMP4 from '../video/roaches.mp4';
import roachVideoPoster from '../images/roach-bg-img.jpg';
import dnrLogoFooter from '../images/DNR-Pest-Logo-white.png';
import generalBugImg from '../images/bug-solid.jpg';
import houseFly from '../images/fly.png';
import commercial from '../images/commercial.svg';
import residential from '../images/residential.svg';
import counties from '../images/florida-counties.svg';


// Adds img src; prevents error in console if element ID doesn't exist on page (null value)
function elementExists(id, filepath, attr = "") {

    var element = document.getElementById(id);

    if(element) {
        if(attr == "poster"){
            element.poster = filepath;
        } else {
            element.src = filepath;
        }
    }
}

elementExists("roachVideoPoster", roachVideoPoster, "poster");
elementExists("comingSoonLogo", dnrLogo);
elementExists("headerLogo", dnrLogo);
elementExists("mobileMenuLogo", dnrLogoFooter);
elementExists("dnrLogoFooter", dnrLogoFooter);
elementExists("dnrLogoHeader", dnrLogoFooter);
elementExists("roachVideoMP4", roachVideoMP4);
elementExists("roachVideoWebM", roachVideoWebM);
elementExists("houseFly", houseFly);
elementExists("commercialSVG", commercial);
elementExists("residentialSVG", residential);
elementExists("countiesSVG", counties);


jQuery(document).ready(function($) {
    $('.general-bug-img').each(function(){
      $(this).attr('src', generalBugImg);
    });
});

